import { Button } from "@freightsimple/ui-core/Controls/Button";
import { useNavigate } from "react-router-dom";

// The empty-state call to action, shown on both the shipments list and the
// invoices list when the company has nothing yet.
export function QuotesGetInstantQuotesButton() {
  const navigate = useNavigate();

  function onClick() {
    navigate("/book/details");
  }

  return (
    <Button primary size="large" onClick={onClick}>
      Get Instant Quotes
    </Button>
  );
}
